import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { GetPricingStatusParameter } from "./PricingStatusModel";
import { getCustomerPriceingStatus } from "./PricingStatusService";
import PricingStatusState from "./PricingStatusState";
import { getStatuscall } from "@NA/Services/ADIgetStatusCall";
type HandlerType = CustomApiHandler<GetPricingStatusParameter, PricingStatusState>;

export const DispatchPricingStatusLoading: HandlerType = (props: any) => {
    props.dispatch({
        type: "HomePage/GetPricingStatus",
        result: props.parameter,
    });
};

export const LoadPricingStatus: HandlerType = async (props: any) => {
    try {
        const response = await getCustomerPriceingStatus(props.parameter.userID);
        props.apiResult = response;
    } catch (error) {
        console.log(error, "error");
    }
};

export const DispatchCompletedPricingStatus: HandlerType = props => {
    props.dispatch({
        type: "Homepage/DispatchCompletePricingStatus",
        pricingStatus: props.apiResult   
    });
};

export const DispatchGetcustomerStatusApi: HandlerType = async (props:any) => {
    try {
        const response:any = await getStatuscall();
        const apiResult:any = response?.response;
        props.dispatch({
            type: "Homepage/getcustomerStatus",   // Type of the action
            result: apiResult || {},     // The data being dispatched as the payload
        })
        
    } catch (error) {
        console.log(error, "error");
    }
};
export const chain = [DispatchPricingStatusLoading, LoadPricingStatus, DispatchCompletedPricingStatus,DispatchGetcustomerStatusApi];

const loadPricingStatus = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        userID: "",
    },
    "loadPricingStatus",
);
export default loadPricingStatus;
